'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'radio-tuner';
var width = 512;
var height = 512;
var aliases = ["radio-alt"];
var unicode = 'f8d8';
var svgPathData = 'M506-16.2l7.8-1.9-3.8-15.6-7.8 1.9-496 120-6.1 1.5 0 390.3 512 0 0-384-470 0 463.9-112.2zM16.2 112l480 0 0 80-480 0 0-80zm0 96l480 0 0 256-480 0 0-256zm352 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80.2 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRadioTuner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;